import Typography from './typography'

export default Typography